import classNames from "classnames/bind";
import { getLinkData } from "@/core/utils";
import { Button } from "@components";
import SearchIcon from "@/assets/svg/search.svg";
import TopLevelLink from "./TopLevelLink/TopLevelLink";
import HeaderDropdown from "../HeaderDropdown/HeaderDropdown";
import { useViewSize } from "@/providers/ViewSizeContext";
import { useSearch } from "@/providers/SearchContext";

import styles from "./DesktopMenu.module.scss";
const cx = classNames.bind(styles);

type DesktopMenuProps =
  SiteNavigation["navigationSettingsFields"] & {
    onSearchClick: () => void;
    hideSearchTray: () => void;
  };

const ComponentMap: { [key: string]: React.ComponentType<any> } = {
  link: TopLevelLink,
  dropdown: HeaderDropdown,
};

export default function DesktopMenu(props: DesktopMenuProps) {
  const { topLevelNavigation, ticketsCta, onSearchClick, hideSearchTray } = props;
  const ticketLinkData = getLinkData(ticketsCta);
  const { isSearchPage } = useSearch();
  const { isDesktop } = useViewSize();
  return (
    <>
      <div className={cx("desktop-menu")}>
        {topLevelNavigation?.map((item, index) => {
          if (!item) return null;
          const Component = ComponentMap[item.type[0]];
          if (!Component) return null;
          return <Component key={index} {...item} hideSearchTray={hideSearchTray} />;
        })}
        <div className={cx("desktop-menu__buttons")} >
          {ticketLinkData && (
            <Button
              className={cx("ticket-button")}
              dataGtmSection="nav"
              {...ticketLinkData}
            />
          )}
          <button
            role="button"
            aria-label="Search"
            value="Search"
            disabled={isSearchPage}
            className={cx(["search-button"])}
            onClick={onSearchClick}
            data-gtm-section="nav"
          >
            <SearchIcon />
          </button>
        </div>
      </div>
    </>
  );
}
